import React, { useState, useEffect } from 'react';

import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import Info from '@material-ui/icons/Info';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import DialogAcoesIndicacao from './DialogAcoesIndicacao';
import { StatusFormated } from 'src/views/Indicacoes/components/MinhasIndicacoes/Pendentes';

import api from 'src/services/data';

import './styles.css';

export default function TodasIndicacoes() {
    const [reloadTable, setReloadTable] = useState(false);
    
    const [indicacoes, setIndicacoes] = useState([]);
    
    const [indicacaoSelecionada, setIndicacaoSelecionada] = useState('');
    const [openDialogAcoesIndicacoes, setOpenDialogAcoesIndicacoes] = useState(false);

    useEffect(() => {
        api.get('api/acesso/indicacoes/listar').then(({data}) => {
            const dataFormat = data.map((indicacao) => {
                const valueComissao = 0;
                
                return {
                    parceiro: indicacao.user.name,
                    cliente: indicacao.pessoa.razao_nome,
                    status: StatusFormated({
                        title: indicacao.status_indicacao.titulo,
                        cor: indicacao.status_indicacao.cor
                    }),
                    comissao: `R$ ${Number(valueComissao).toFixed(2)}`,
                    btnActions: (
                        <center>
                            <IconButton
                                title="Detalhes"
                                style={{ color: '#0e3e94' }}
                                onClick={() => {
                                    setIndicacaoSelecionada(indicacao.id);
                                    setOpenDialogAcoesIndicacoes(true);
                                }}
                            >
                                <Info />
                            </IconButton>
                        </center>
                    )
                }
            });

            setIndicacoes(dataFormat);
        }).catch(console.log)
    }, [reloadTable])

    return (
        <Container maxWidth="xl">
            <DataTable
                value={indicacoes}
                rows={15}
                paginator
                responsive
                style={{ textAlign: 'center' }}
            >
                <Column
                    header="Parceiro"
                    field="parceiro"
                    filter
                    filterMatchMode="contained"
                />

                <Column
                    header="Cliente"
                    field="cliente"
                    filter
                    filterMatchMode="contained"
                />

                <Column
                    header="Comissão R$"
                    field="comissao"
                    filter
                    filterMatchMode="contained"
                />

                <Column
                    header="Status"
                    field="status"
                />

                <Column
                    header="Ações"
                    field="btnActions"
                />
            </DataTable>

            <DialogAcoesIndicacao
                open={openDialogAcoesIndicacoes}
                idIndicacao={indicacaoSelecionada}
                reload={reloadTable}
                setOpen={setOpenDialogAcoesIndicacoes}
                setIdIndicacao={setIndicacaoSelecionada}
                setReload={setReloadTable}
                withActions={true}
            />
        </Container>
    )
}